import { createRoot } from 'react-dom/client';
import { enableGlobalTheme } from '@atlaskit/tokens/enable-global-theme';
import { getThemeStyles } from '@atlaskit/tokens/get-theme-styles';

import { App } from '@app/app';
import { OneTrustProvider, HelmetProvider } from '@app/onetrust';
import { FeatureGateProvider } from '@app/feature-gates';
import { UserProvider } from '@app/auth';
import { api } from '@app/app/src/QueryClient';

import '@atlaskit/css-reset/dist/bundle.css';
import './assets/css/global.css';
import '@atlassian/learning-components/dist/styles/index.css';

const THEME_CONFIG = {
  colorMode: 'light' as const,
  light: 'light' as const,
  dark: 'dark' as const,
  spacing: 'spacing' as const,
};

// Load and inject theme styles
getThemeStyles(THEME_CONFIG).then((themeStyles) => {
  themeStyles.forEach(({ css, attrs }) => {
    const style = document.createElement('style');
    style.textContent = css;
    Object.entries(attrs).forEach(([key, value]) => {
      style.setAttribute(key, value);
    });
    document.head.appendChild(style);
  });
});

// Initialize global theme for runtime theme switching
enableGlobalTheme(THEME_CONFIG);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <OneTrustProvider>
      <HelmetProvider>
        <UserProvider api={api}>
          <FeatureGateProvider>
            <App />
          </FeatureGateProvider>
        </UserProvider>
      </HelmetProvider>
    </OneTrustProvider>,
  );
}
